// extracted by mini-css-extract-plugin
export default {"form-container":"contact-board_modal_form-container__Qf9Ho","content-container":"contact-board_modal_content-container__PKF9Y","date-picker":"contact-board_modal_date-picker__KffHd"};